import { render, staticRenderFns } from "./BannersDisclosure.vue?vue&type=template&id=7be83768&scoped=true"
import script from "./BannersDisclosure.vue?vue&type=script&lang=js"
export * from "./BannersDisclosure.vue?vue&type=script&lang=js"
import style0 from "./BannersDisclosure.vue?vue&type=style&index=0&id=7be83768&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7be83768",
  null
  
)

export default component.exports